/** Entry point of the tainan package (Tainan). Imported once from main.ts. */
import '../render/propsTainan';
import './tainan';
import { registerNpcs } from '../world/npcs';
import { NPCS_TAINAN } from '../world/npcsTainan';

registerNpcs(NPCS_TAINAN);
